"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultUrlFilter = getDefaultUrlFilter;
exports.getDefaultHideUrlFilter = getDefaultHideUrlFilter;
exports.getDefaultUrlGroupFilter = getDefaultUrlGroupFilter;
exports.getDefaultBlankFilter = getDefaultBlankFilter;
exports.getDefaultShowFilter = getDefaultShowFilter;
exports.getDefaultHideFilter = getDefaultHideFilter;
exports.getInitialFilter = getInitialFilter;
exports.getNewFilterGroup = getNewFilterGroup;
exports.getAudienceFilters = getAudienceFilters;
exports.getFilterGroups = getFilterGroups;
exports.filterById = filterById;
exports.ommitId = ommitId;
exports.filterByGroup = filterByGroup;
exports.updateGroupValues = updateGroupValues;
exports.noShowValues = noShowValues;
exports.getFirstOperator = getFirstOperator;
exports.getOrValues = getOrValues;
exports.hasEmptyValues = hasEmptyValues;
exports.getFilterPath = getFilterPath;
exports.getValuesPath = getValuesPath;
exports.getFirstAndValue = getFirstAndValue;
exports.isURLType = isURLType;
exports.isFirstURL = isFirstURL;
exports.isFilterAll = isFilterAll;
exports.validateValues = validateValues;
exports.hasUrlFilter = hasUrlFilter;
exports.hasNotURLFilter = hasNotURLFilter;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _FilterRecord = _interopRequireDefault(require("AudienceTargetingUIComponents/constants/FilterRecord"));

var _validationUtils = require("AudienceTargetingUIComponents/utils/validationUtils");

var _Operators = require("AudienceTargetingUIComponents/constants/Operators");

var _createUUID = _interopRequireDefault(require("./createUUID"));

var urlTypes = {
  URL: true,
  PAGE_VISITS: true,
  REFERRER: true
};
var urlOperators = {
  EQ: true,
  STR_STARTS_WITH: true
};

function isImmutable(obj) {
  return obj && _immutable.Iterable.isIterable(obj);
}

function getDefaultUrlFilter() {
  return new _FilterRecord.default({
    operator: 'ALL',
    type: 'URL',
    values: ''
  });
}

function getDefaultHideUrlFilter() {
  return new _FilterRecord.default({
    operator: 'EQ',
    type: 'URL',
    values: ''
  });
}

function getDefaultUrlGroupFilter(groupId) {
  return new _immutable.Map({
    operator: 'OR',
    groupId: groupId || (0, _createUUID.default)(),
    type: 'BOOLEAN',
    values: new _immutable.List([getDefaultUrlFilter()])
  });
}

function getDefaultBlankFilter(groupId, filter) {
  var newFilter = filter || new _immutable.Map({
    operator: _Operators.EQ,
    values: undefined,
    type: null
  });
  var blankFilter = new _immutable.Map({
    operator: 'OR',
    type: 'BOOLEAN',
    values: new _immutable.List([newFilter])
  });

  if (groupId) {
    blankFilter = blankFilter.set('groupId', groupId);
  }

  return blankFilter;
}

function getDefaultShowFilter() {
  var defaultFilter = getDefaultUrlGroupFilter();
  console.log(defaultFilter.toJS());
  return new _FilterRecord.default({
    type: 'BOOLEAN',
    operator: 'AND',
    values: new _immutable.List([defaultFilter])
  });
}

function getDefaultHideFilter(groupId) {
  var isURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var filter = isURL && getDefaultHideUrlFilter();
  var hideFilter = new _immutable.Map({
    type: 'BOOLEAN',
    operator: 'NOT',
    groupId: groupId,
    values: new _immutable.List([getDefaultBlankFilter(undefined, filter)])
  });
  return hideFilter;
}

function getInitialFilter() {
  var defaultUrlGroup = getDefaultUrlGroupFilter();
  var defaultBlankFilter = getDefaultBlankFilter((0, _createUUID.default)());
  var defaultFilters = [defaultUrlGroup, defaultBlankFilter];
  return new _FilterRecord.default({
    type: 'BOOLEAN',
    operator: 'AND',
    values: new _immutable.List(defaultFilters)
  });
}

function getNewFilterGroup() {
  var operator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'OR';
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'BOOLEAN';
  return new _FilterRecord.default({
    values: new _immutable.List([new _FilterRecord.default()]),
    operator: operator,
    type: type
  });
}

function getAudienceFilters(audience) {
  var filters = audience ? audience.filters : getInitialFilter();
  return (0, _immutable.fromJS)(filters);
}

function getFilterGroups(filter) {
  var normalizedFilter = isImmutable(filter) ? filter.toJS() : filter;
  var groupsById = normalizedFilter.values.reduce(function (groups, filterGroup) {
    var groupId = filterGroup.groupId;
    if (!groups[groupId]) groups[groupId] = [];
    groups[groupId].push(filterGroup);
    return groups;
  }, {});
  var groupsArray = Object.keys(groupsById).map(function (id) {
    return groupsById[id];
  });
  return (0, _immutable.fromJS)(groupsArray);
}

function filterById(filters, id) {
  return (0, _defineProperty2.default)({}, id, filters[id]);
}

function ommitId(filter) {
  var id = filter.id,
      noId = (0, _objectWithoutProperties2.default)(filter, ["id"]);
  return {
    id: id,
    noId: noId
  };
}

function filterByGroup(filters, group) {
  return Object.keys(filters).map(function (i) {
    return (0, _extends3.default)({
      id: i
    }, filters[i]);
  }).filter(function (i) {
    return i.group === group;
  }).reduce(function (acc, i) {
    return (0, _extends3.default)({}, acc, (0, _defineProperty2.default)({}, ommitId(i).id, ommitId(i).noId));
  }, {});
}

function updateGroupValues(filter, rootGroup, group) {
  switch (rootGroup) {
    case 'SHOW':
      return filter.setIn(['values', 0, 'values'], group);

    case 'HIDE':
      return filter.setIn(['values', 1, 'values', 0, 'values'], group);

    default:
      return filter;
  }
}

function noShowValues(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  var values = immutableFilter.getIn(['values', 0, 'values', 0, 'values']); // eslint-disable-next-line no-extra-boolean-cast

  return !Boolean(values);
}

function getFirstOperator(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  return immutableFilter.getIn(['values', 0, 'values', 0, 'values', 0, 'operator']);
}

function getOrValues(filters) {
  var values;
  var normalizedFilters = filters.get ? filters : (0, _immutable.fromJS)(filters);

  if (normalizedFilters.get('operator') === 'OR') {
    return normalizedFilters.get('values');
  }

  values = normalizedFilters.get('values') || normalizedFilters;
  values = values.get(0);
  return getOrValues(values);
}

function hasEmptyValues(filter) {
  var values = filter.get('values');
  var withValues = values.filter(function (group) {
    var vals = getOrValues(group);
    var filtered = vals.filter(function (f) {
      return Boolean(f.get('values') || f.get('operator') === 'ALL');
    });
    return Boolean(filtered.size);
  });
  return Boolean(withValues.size < values.size);
}

function getFilterPath(filters, type, groupId, filterIndex) {
  var values = filters.get('values');
  var groupIndex = values.findIndex(function (filter) {
    return filter.get('groupId') === groupId && filter.get('operator') === type;
  });
  var extraLevel = type === 'NOT' ? [0, 'values'] : [];
  return ['values', groupIndex, 'values'].concat(extraLevel, [filterIndex]);
}

function getValuesPath(filters, valuesPath) {
  var keyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['operator', 'OR'];

  var _keyValue = (0, _slicedToArray2.default)(keyValue, 2),
      key = _keyValue[0],
      value = _keyValue[1];

  if (filters.getIn([].concat((0, _toConsumableArray2.default)(valuesPath), [0, key])) === value) {
    return valuesPath;
  }

  return getValuesPath(filters, [].concat((0, _toConsumableArray2.default)(valuesPath), [0, 'values']), keyValue);
}

function getFirstAndValue(filter) {
  var immutableFilter = isImmutable(filter) ? filter : (0, _immutable.fromJS)(filter);
  var value = immutableFilter.getIn(['values', 0, 'values', 0, 'values', 0]);
  return value;
}

function isURLType(value) {
  var normalizedValue = value && value.get('operator') === 'OR' ? getOrValues(value).get(0) : value;
  return normalizedValue ? normalizedValue.get('type') === 'URL' || normalizedValue.get('type') === 'QUERY_PARAM' : false;
}

function isFirstURL(filter) {
  var firstAndValue = filter && getFirstAndValue(filter);
  return isURLType(firstAndValue);
}

function isFilterAll(filter) {
  var operator = filter && getFirstOperator(filter);
  return operator === 'ALL';
}

function validateValues(vals) {
  if (!vals.map) {
    return true;
  }

  return vals.map(function (val) {
    return (0, _immutable.fromJS)(val);
  }).every(function (val) {
    if (!val.get) {
      return true;
    }

    var values = val.get('values');
    var type = val.get('type');
    var operator = val.get('operator');

    if (values) {
      if (Array.isArray(values)) {
        return Boolean(values.length);
      } else {
        if (urlTypes[type] && urlOperators[operator]) {
          return (0, _validationUtils.isValidUrl)(values);
        } else if (type === 'QUERY_PARAM') {
          return Boolean(values.name) && Boolean(values.value);
        } else if (_immutable.List.isList(values)) {
          return validateValues(values);
        } else {
          return Boolean(values);
        }
      }
    } else if (operator === 'ALL') {
      return true;
    } else {
      return false;
    }
  });
}

function hasUrlFilter(filter) {
  var values = filter.get ? filter.get('values') : filter.values;
  var urlValues = values.filter(function (f) {
    var vals = getOrValues(f);
    var filtered = vals.filter(function (val) {
      return val.get('type') === 'URL' || val.get('type') === 'QUERY_PARAM';
    });
    return Boolean(filtered.size);
  });
  return Boolean(urlValues.size);
}

function hasNotURLFilter(filter) {
  var values = filter.get ? filter.get('values') : filter.values;
  var notURLValues = values.filter(function (f) {
    var vals = getOrValues(f);
    var filtered = vals.filter(function (val) {
      return val.get('type') !== 'URL' && val.get('type') !== 'QUERY_PARAM';
    });
    return Boolean(filtered.size);
  });
  return Boolean(notURLValues.size);
}